import { StatusDot } from "@/components/ui";
import { MarkdownContent } from "@/components/ui/markdown-content";
import { AgentStatusText } from "@/components/cursors/agent-status-text";
import type { PillContent } from "./compact-cursor-pill-content";
import { useT } from "@/i18n";
import { compactCursorMessages } from "@/i18n/messages/compact-cursor";

export function PillText({ content }: { content: PillContent }) {
  const t = useT(compactCursorMessages);
  if (content.kind === "confirm") return <span>✓ {content.label}</span>;
  if (content.kind === "question") return null;
  if (content.kind === "tool" || content.kind === "thinking") {
    return (
      <span className="flex items-start gap-1.5">
        <AgentStatusText
          text={content.text}
          working={content.kind === "thinking" || !content.failed}
          className="whitespace-pre-wrap break-words"
        />
        {content.kind === "tool" && content.failed && (
          <span
            data-pill-trailing-mark
            className="flex h-[1lh] shrink-0 items-center"
          >
            <StatusDot tone="error" label={t("toolFailed")} />
          </span>
        )}
      </span>
    );
  }
  return (
    <span className="flex items-start gap-1.5">
      {content.kind === "error" && (
        <span className="flex h-[1lh] shrink-0 items-center">
          <StatusDot tone="error" />
        </span>
      )}
      {content.kind === "reply" ? (
        <MarkdownContent
          content={content.text}
          className="[overflow-wrap:anywhere]"
        />
      ) : (
        <span className="whitespace-pre-wrap break-words">{content.text}</span>
      )}
    </span>
  );
}
